import path from 'path'
import type { UploadCollectionSlug, PayloadRequest } from 'payload'
import { wlodevImagePath, wlodevS3Path } from '../config.js'

// This is only meant to indicate what path we want like
// in getWlodevImageOptimizationPath function to avoid confusion
type WlodevFilePath = string

export const getWlodevFilePath = (
    collectionSlug: UploadCollectionSlug,
    filename: string
): WlodevFilePath => {
    const imageBasePath = path.posix.join(wlodevS3Path)
    const imageSearchParams = new URLSearchParams({
        collection: collectionSlug,
        key: filename,
    })

    const imagePath = `${imageBasePath}?${imageSearchParams.toString()}`
    return imagePath
}

export const getWlodevImageOptimizationPath = ({
    imagePath,
    quality = 50,
    width = 320,
}: {
    imagePath: WlodevFilePath
    quality?: number
    width?: number
}) => {
    const optimizationBasePath = path.posix.join(wlodevImagePath)
    const optimizationSearchParams = new URLSearchParams({
        w: String(width),
        q: String(quality),
        url: imagePath,
    })
    const optimizationPath = `${optimizationBasePath}?${optimizationSearchParams.toString()}`
    return optimizationPath
}

export const getLocalUploadURL = (path: string, req: PayloadRequest) => {
    try {
        const url = new URL(`${req.protocol}//${req.host}`)
        url.pathname = path
        return url
    } catch (err) {
        console.error(`Invalid localhost cms image url: ${path}, error: ${err}`)
    }
    return null
}
